module.exports = __webpack_public_path__ + "static/media/rp02.b53d4dc7.webp";